import reducer from './reducer';
import * as selectors from './selectors';
import * as actionTypes from './actionTypes';
import * as actions from './actions';

const exportedObjects = { reducer, selectors, actionTypes, actions};

export default exportedObjects;
